import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { collectionGroup, doc, getDoc, getDocs, limit, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { Lock, SearchX, UserRound } from "lucide-react";
import { db } from "../firebase/config";
import { AthleteDetailsPage } from "../athletes/AthleteDetailsPage";
import { getPublicTeamSeasonId, publicTeamSectionUrl } from "./publicTeamNavigation";
function athleteFromData(athleteId, data) {
    return {
        id: String(data.id ?? athleteId),
        firstName: String(data.firstName ?? ""),
        lastName: String(data.lastName ?? ""),
        classOf: Number(data.classOf ?? Number.NaN),
        seasons: Array.isArray(data.seasons) ? data.seasons.map(String) : [],
        type: String(data.type ?? "Other"),
        photo: data.photo,
    };
}
export function PublicAthletePage({ athleteId }) {
    const [state, setState] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    useEffect(() => {
        let active = true;
        async function loadAthlete() {
            setLoading(true);
            setError("");
            setState(null);
            try {
                const athleteSnapshot = await getDocs(query(collectionGroup(db, "roster"), where("id", "==", athleteId), limit(1)));
                const athleteDocument = athleteSnapshot.docs[0];
                const teamRef = athleteDocument?.ref.parent.parent;
                if (!athleteDocument || !teamRef) {
                    if (active)
                        setError("This athlete could not be found.");
                    return;
                }
                const teamSnapshot = await getDoc(doc(db, "teams", teamRef.id));
                if (!teamSnapshot.exists()) {
                    if (active)
                        setError("This athlete could not be found.");
                    return;
                }
                const team = { id: teamSnapshot.id, ...teamSnapshot.data() };
                if (team.public !== true) {
                    if (active)
                        setError("This athlete is not available for public viewing.");
                    return;
                }
                if (active)
                    setState({ team, athlete: athleteFromData(athleteDocument.id, athleteDocument.data()) });
            }
            catch (caughtError) {
                if (active)
                    setError(caughtError instanceof Error ? caughtError.message : "This athlete could not be loaded.");
            }
            finally {
                if (active)
                    setLoading(false);
            }
        }
        void loadAthlete();
        return () => {
            active = false;
        };
    }, [athleteId]);
    if (loading) {
        return _jsx("main", { className: "main-standalone", children: _jsx("div", { className: "content", children: _jsxs("div", { className: "details-state", children: [_jsx(UserRound, { size: 24 }), _jsx("strong", { children: "Loading athlete..." })] }) }) });
    }
    if (error || !state) {
        return _jsx("main", { className: "main-standalone", children: _jsx("div", { className: "content", children: _jsxs("div", { className: "details-state details-state--error", children: [error.includes("public") ? _jsx(Lock, { size: 24 }) : _jsx(SearchX, { size: 24 }), _jsx("strong", { children: "Athlete unavailable" }), _jsx("span", { children: error || "This athlete could not be loaded." })] }) }) });
    }
    return (_jsx("main", { className: "main-standalone", children: _jsx(AthleteDetailsPage, { athlete: state.athlete, publicContext: { team: state.team }, readOnly: true, showBackButton: true, onBack: () => { window.location.href = publicTeamSectionUrl(state.team.slug, "Roster", getPublicTeamSeasonId()); } }) }));
}
